import { Tooltip, type TooltipProps } from '@mui/material';

import RequestAccessBlock from './RequestAccessBlock';

import { type PermissionActionEnum, type PermissionEntityEnum } from '@/graphql/generated/graphql';

interface RequestPermissionTooltipProps {
  children: React.JSX.Element;
  hasPermission: boolean;
  requiredPermission: {
    action: PermissionActionEnum;
    entity: PermissionEntityEnum;
  };
  checkRequestExists: (action: PermissionActionEnum, entity: PermissionEntityEnum) => boolean;
  onRequest: (action: PermissionActionEnum, entity: PermissionEntityEnum, projectId?: string) => void;
  placement?: TooltipProps['placement'];
  title?: TooltipProps['title']; // only used when the user has permission
}

const RequestPermissionTooltip = ({
  children,
  hasPermission,
  requiredPermission,
  checkRequestExists,
  onRequest,
  placement = 'bottom',
  title,
}: RequestPermissionTooltipProps) => {
  if (hasPermission && title == null) {
    return children;
  }

  const tooltipTitle = hasPermission ? (
    title
  ) : (
    <RequestAccessBlock
      requiredPermission={requiredPermission}
      checkRequestExists={checkRequestExists}
      onRequest={onRequest}
    />
  );

  return (
    <Tooltip arrow placement={placement} title={tooltipTitle}>
      <span>{children}</span>
    </Tooltip>
  );
};

export default RequestPermissionTooltip;
